import React, { type FC } from "react";
import type { Enterprise } from "@src/api/dictionaries/enterprise";

/** Минимальный контракт предприятия для отображения. */
export type BusinessEnterpriseValueEnterprise = Pick<Enterprise, "Name" | "ShortName" | "WsCode">;

/** Пропсы компонента {@link BusinessEnterpriseValue}. */
export interface BusinessEnterpriseValueProps {
    /** Предприятие; отображается краткое имя, полное имя или заводской код. */
    enterprise?: BusinessEnterpriseValueEnterprise | null;
    /** Текст или узел для пустого предприятия. @default "Не задано" */
    fallback?: React.ReactNode;
    /** Дополнительный CSS-класс корневого контейнера. */
    className?: string;
}

/**
 * Формирует plain-text представление предприятия.
 * @param enterprise предприятие
 * @returns подпись предприятия или пустая строка, если данных нет
 */
export function formatEnterpriseText(enterprise?: BusinessEnterpriseValueEnterprise | null): string {
    const shortName = enterprise?.ShortName?.trim() ?? "";
    if (shortName !== "") {
        return shortName;
    }

    const name = enterprise?.Name.trim() ?? "";
    if (name !== "") {
        return name;
    }

    return enterprise?.WsCode?.trim() ?? "";
}

/** Read-only отображение предприятия-контрагента. */
export const BusinessEnterpriseValue: FC<BusinessEnterpriseValueProps> = ({
    enterprise,
    fallback = "Не задано",
    className,
}) => {
    const text = formatEnterpriseText(enterprise);

    if (text === "") {
        return <span className={className}>{fallback}</span>;
    }

    return <span className={className}>{text}</span>;
};
